import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import { IOfferSpend } from '../../types'
import { ToolPanel } from '../ui'
import { OfferSpendHistoryListTable } from './OfferSpendHistoryListTable'
import { ALL_LANG_KEY } from '../../types/lang'
import { useTranslation } from 'react-i18next'

type IOfferSpendHistoryListModalProps = {
	offerSpend: IOfferSpend | null;
	show: boolean;
	take: number | 'all';
	onClose: () => void;
}

export const OfferSpendHistoryListModal = (
	props: IOfferSpendHistoryListModalProps
) => {
	const { offerSpend, show, take = 10, onClose } = props
	const { t } = useTranslation()
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	const modalTitle = `${t(ALL_LANG_KEY.offer_spend_crud_modal.title_history_view)} #${offerSpend?.id}`

	return <>
		<Modal show={show} onHide={onClose} size="xl" className={'modal-with-sticky scroll'}>
			<Modal.Header className={'modal-header--sticky'} closeButton>
				<Modal.Title>{modalTitle}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<OfferSpendHistoryListTable
					items={offerSpend?.history ?? []}
					skip={skip}
				/>
			</Modal.Body>

			<Modal.Footer className={'modal-footer--sticky'}>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.offer_spend_crud_modal.btn_close)}`}</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
